"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var split_join_1 = require("../split-join");
exports.getAllPrefixes = function (key) {
    return split_join_1.TweekKeySplitJoin.split(key)
        .slice(0, -1)
        .reduce(function (acc, next) { return acc.concat([acc.slice(-1).concat([next]).join('/')]); }, []);
};
exports.getKeyPrefix = function (key) {
    return split_join_1.TweekKeySplitJoin.split(key)
        .slice(0, -1)
        .join('/');
};
exports.isScanKey = function (key) { return key === '_' || key.endsWith('/_'); };
//# sourceMappingURL=keyUtils.js.map


// WEBPACK FOOTER //
// ../../src/utils/keyUtils.ts